var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",staticClass:"cube-entry",attrs:{"href":_vm.data.link_url}},[_c('div',{staticClass:"image-block"},[_c('van-image',{attrs:{"src":_vm.data.image_url,"fit":"cover"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }